import { combineReducers } from '@reduxjs/toolkit';
import watchReducer from './Slices/WatchSlice';
import cartReducer from './Slices/CartSlice';
import checkoutReducer from './Slices/CheckoutSlice';

export const rootReducer = combineReducers({
  watch: watchReducer,
  cart: cartReducer,
  checkout: checkoutReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
